<template lang="pug">
div.wrap-module-asset-selector-by-favorite.w-full.h-full
  div.asset-selector-by-favorite-content.relative.pt12
    div(ref="wrapAssets" v-show="!isLoading"
      ).wrap-result.relative.f.flex-between.flex-wrap.pb100.overflow-scroll
      ItemAssetCardToAdd(v-for="asset in assets" :key="asset.id"
        :asset="asset" :user="user"
        :assetIdsToAdd="assetIdsToAdd" :selfRatings="selfRatings"
        @addSelectedAsset="addSelectedAsset")
      div(v-if="isInitialzed && !assets[0]").w-full.f.fh
        span.fz16 お気に入りに追加されたアセットがありません
    div(v-if="isLoading").wrap-loading.f.fh
      v-progress-circular(:color="pallete.$active_color" indeterminate)
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-asset-selector-by-favorite {
  // height: calc(100vh - 200px);
  .asset-selector-by-favorite-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
    .wrap-result, .wrap-loading {
      height: calc(#{$device_height} - 64px);
    }
    .wrap-result {
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {  /* Chrome, Safari 対応 */
        display:none;
      }
    }
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import ItemAssetCardToAdd from '@/components/item/studio/ItemAssetCardToAdd'

export default {
  components: {
    ItemAssetCardToAdd
  },
  props: {
    assetType: {
      type: Object,
      default: null
    },
    assetIdsToAdd: {
      type: Array,
      required: true
    },
    selfRatings: {
      type: Object,
      default: null
    },
    user: {
      type: Object,
      default: null
    },
    frame: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    showingAssetIds () {
      return this.assets.map(a => a.id)
    }
  },
  data () {
    return {
      assets: [],
      favoriteAssetIds: [],
      loadMoreAssets: true,
      loadLimit: 8,
      isLoading: false, isLoadingByScroll: false,
      isInitialzed: false
    }
  },
  async created () {
    this.favoriteAssetIds = this.user.favoriteAssets.slice().reverse()

    this.isLoading = true
    await this.loadAssets()
    this.isLoading = false
    this.isInitialzed = true
  },
  mounted () {
    this.$refs.wrapAssets.addEventListener('scroll', this.onScroll)
  },
  beforeUnmount () {
    this.$refs.wrapAssets.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      const wrapAssets = this.$refs.wrapAssets
      if ((wrapAssets.scrollHeight - wrapAssets.clientHeight) <=  wrapAssets.scrollTop + 4) {
        this.loadAssets()
      }
    },
    async loadAssets () {
      if (!this.loadMoreAssets || this.isLoadingByScroll) return
      this.isLoadingByScroll = true

      const newFavoriteAssetIds = this.favoriteAssetIds.filter(id => {
        return !this.showingAssetIds.includes(id)
      }).slice(0, this.loadLimit)
      if (!newFavoriteAssetIds[0]) {
        this.loadMoreAsset = false
        return
      }
      const newAssets = await database.assetCollection()
        .getAssetsByIds(newFavoriteAssetIds)
      this.assets = this.assets.concat(newAssets)    
      
      this.isLoadingByScroll = false
    },
    addSelectedAsset (assetId) {
      this.$emit('addSelectedAsset', assetId)
    },
  }
}
</script>
